import { apiFetch } from '@ami/react/core';

const _baseEndPoint = 'machines/bolt-on-mount/types';
export class BoltOnMountType {
  constructor(item) {
    this.id = item.id;
    this.label = item.label;
  }

  static async all() {
    const entities = await apiFetch(`${_baseEndPoint}`);
    return entities.map((x) => new BoltOnMountType(x));
  }
}
